import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.map.js";
import { getAllChildren } from 'utils/tree';
/**
 * Create a mapping of all section ids to an array their children ids.
 * This is useful to quickly get all ids of the children of a section,
 * and also to quickly find out whether any given id belongs to a section
 * (`sectionContentMap.has(id)`)
 */

export function getSectionContentMap(content) {
  var sectionContentMap = new Map();
  content.forEach(function (contentItem) {
    if (contentItem.type === 'section') {
      sectionContentMap.set(contentItem.id, getAllChildren(content, contentItem.id).map(function (child) {
        return child.id;
      }));
    }
  });
  return sectionContentMap;
}